<template>
  <div class="d-flex align-center">
    <component
      class="flex-grow-1"
      :is="criteriaComponent"
      ref="criteria"
      :params="criteria.params"
      :current-search-details="currentSearchDetails"
      @submit="submit"
    />
    <v-btn icon class="ml-2" @click="removeCriteria">
      <v-icon>delete</v-icon>
    </v-btn>
  </div>
</template>
<script>
import KeywordFilter from './criterias/KeywordFilter';
import TimeWindowFilter from './criterias/TimeWindowFilter';
import SemanticSearch from './criterias/SemanticSearch';
import TimeDecay from './criterias/TimeDecay';
import KeywordScore from './criterias/KeywordScore';
import UrlScore from './criterias/UrlScore';
import UrlFilter from './criterias/UrlFilter';
import PortfolioBias from './criterias/PortfolioBias';

export const criterias = {
  KEYWORD_FILTER: 'KEYWORD_FILTER',
  TIME_WINDOW_FILTER: 'TIME_WINDOW_FILTER',
  KEYWORD_SCORE: 'KEYWORD_SCORE',
  TIME_DECAY: 'TIME_DECAY',
  SEMANTIC_SEARCH: 'SEMANTIC_SEARCH',
  URL_SCORE: 'URL_SCORE',
  PORTFOLIO_BIAS: 'PORTFOLIO_BIAS',
  URL_FILTER: 'URL_FILTER',
};

export default {
  name: 'SearchCriteria',
  props: {
    criteria: {
      type: Object,
      required: true,
    },
    currentSearchDetails: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    criteriaComponent() {
      switch (this.criteria.type) {
        case criterias.KEYWORD_FILTER:
          return KeywordFilter;
        case criterias.TIME_WINDOW_FILTER:
          return TimeWindowFilter;
        case criterias.TIME_DECAY:
          return TimeDecay;
        case criterias.KEYWORD_SCORE:
          return KeywordScore;
        case criterias.SEMANTIC_SEARCH:
          return SemanticSearch;
        case criterias.URL_SCORE:
          return UrlScore;
        case criterias.URL_FILTER:
          return UrlFilter;
        case criterias.PORTFOLIO_BIAS:
          return PortfolioBias;
        default:
          console.error('Unknown criteria type', this.criteria.type, this.criteria);
      }
      throw Error(`Unknown criteria type ${this.criteria.type}, ${this.criteria}`);
    },
  },
  methods: {
    getCriteria() {
      return {
        type: this.type,
        key: this.key,
        criteria: this.$refs.criteria.getCriteria(),
      };
    },
    removeCriteria() {
      this.$emit('remove-criteria', {
        key: this.criteria.key,
        type: this.criteria.type,
      });
    },
    submit() {
      this.$emit('submit');
    },
  },
};
</script>
